import React from "react";
import { FiStar } from "react-icons/fi";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Priya & Arjun",
      role: "Wedding Celebration",
      text: "Studio44 captured our wedding perfectly. Every photo tells our story beautifully. Their attention to detail and creativity exceeded our expectations!",
      rating: 5,
    },
    {
      name: "Aisha & Rahul",
      role: "Pre-Wedding Shoot",
      text: "The pre-wedding shoot was an absolute joy! The team made us comfortable and the results are stunning. Highly recommended for anyone seeking premium photography.",
      rating: 5,
    },
    {
      name: "The Sharma Family",
      role: "Baby Shower",
      text: "From start to finish, Studio44 was professional and creative. The baby shower photos are beautiful and we'll cherish them forever. Thank you!",
      rating: 5,
    },
  ];

  return (
    <section id="testimonials" className="bg-black py-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-20">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-[2px] bg-gradient-to-r from-amber-400 to-transparent"></div>
            <p className="text-xs uppercase tracking-[4px] text-amber-400 font-bold">
              Testimonials
            </p>
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-white">
            Loved by Our Clients
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((item, idx) => (
            <div
              key={idx}
              className="relative p-8 bg-gradient-to-br from-gray-900 to-black border border-gray-800 hover:border-amber-400 transition-all duration-300 group"
            >
              <div className="flex gap-1 mb-6">
                {[...Array(item.rating)].map((_, i) => (
                  <FiStar key={i} size={18} className="fill-amber-400 text-amber-400" />
                ))}
              </div>

              <p className="text-gray-300 leading-relaxed mb-8 italic">
                "{item.text}"
              </p>

              <div>
                <h4 className="font-bold text-white">{item.name}</h4>
                <p className="text-sm text-amber-400 font-medium">{item.role}</p>
              </div>

              <div className="absolute top-6 right-6 text-6xl text-amber-400/10">"</div>
              <div className="absolute inset-0 bg-gradient-to-br from-amber-400/0 to-amber-400/0 group-hover:from-amber-400/5 group-hover:to-amber-400/10 transition pointer-events-none"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;